// Importing all filters
import './split.filter'
import './unique.filter'